import React from "react";
import { colorForScore, scoreText, ringDash } from "../utils/scoring";

export default function ScoreRing({ score, size = 240 }) {
  const color = colorForScore(score);

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 130 130" style={{ transform: "rotate(-90deg)" }}>
        <circle cx="65" cy="65" r="54" fill="none" stroke="rgba(255,255,255,.08)" strokeWidth="11" />
        <circle cx="65" cy="65" r="54" fill="none" stroke={color} strokeWidth="11" strokeLinecap="round" strokeDasharray={ringDash(score)} />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontFamily: "var(--font-heading)", fontSize: 72, lineHeight: 0.85, color }}>{scoreText(score)}</span>
      </div>
    </div>
  );
}
